// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Thread,
    ThreadFromJSON,
    ThreadToJSON,
} from './';

/**
 * 
 * @export
 * @interface ThreadList
 */
export interface ThreadList {
    /**
     * 
     * @type {number}
     * @memberof ThreadList
     */
    count: number;
    /**
     * 
     * @type {Array<Thread>}
     * @memberof ThreadList
     */
    results: Array<Thread>;
}

export function ThreadListFromJSON(json: any): ThreadList {
    return {
        'count': json['count'],
        'results': (json['results'] as Array<any>).map(ThreadFromJSON),
    };
}

export function ThreadListToJSON(value?: ThreadList): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'count': value.count,
        'results': (value.results as Array<any>).map(ThreadToJSON),
    };
}


